import { ChangeDetectionStrategy, Component } from '@angular/core';

import packageInfo from '../../../../../package.json';

/**
 * Renders the frontend build version (KOR-15062).
 *
 * Presentation-free on purpose: the host is a bare block and consumers style the
 * `app-version` element from their own stylesheet, so the sidebar and the auth
 * footer can look different while the format stays defined in one place.
 *
 * No aria-label: ARIA prohibits it on role=generic, so on a bare span it is
 * skipped by the accessible-name computation and never announced. The visible
 * text is the accessible name.
 *
 * The version is read from package.json at build time — the same value main.ts
 * reports to Sentry as the release tag — so a `[System] Bump version to:` commit
 * is the only thing that changes it. The default import mirrors main.ts: the
 * bundler rejects named imports from JSON modules, and package.json is already
 * bundled for Sentry, so this adds no bytes.
 */
@Component({
  selector: 'app-version',
  template: `<span>v{{ version }}</span>`,
  styles: ':host { display: block; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class AppVersionComponent {
  readonly version = packageInfo.version;
}
